import React, { useState } from 'react';
import logo from '../../logo.svg';
import { Link } from 'react-scroll';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const Navbar = () => {
 const mobile = window.innerWidth<=768?true:false;
 console.log(mobile);
 
 const [menuOpened,setmenuOpened]=useState(false);
  return (
    <div className='bg-gradient-to-r from-sky-400 to-indigo-900 px-4 md:h-[96px] h-[48px] flex items-center justify-between sticky top-0 z-50 border-b-[1px] border-white '>
        <div className='flex items-center relative'>
            <span className='text-white font-bold text-3xl md:text-4xl'>&lt;</span>
            <img src={logo} alt="Logo" className='w-[40px] md:w-[60px] App-logo absolute md:left-6 left-4'  />
            <span className='text-white font-bold text-3xl md:text-4xl md:ml-14 ml-8'>&#47;&gt;</span>
        </div>
        {
      (mobile===true && menuOpened===false)?(
        <div onClick={()=>{
          setmenuOpened(true);
        }}>
          <FontAwesomeIcon icon={faBars}  className='text-white size-7'/>
        </div>
       ):(<div className='md:mr-8'>
          <ul className='flex md:gap-16 md:text-white md:text-2xl md:font-semibold flex-col md:flex-row relative top-16 md:top-0 md:bg-inherit bg-white text-blue-900 p-4 md:p-0 rounded-sm font-semibold'>
            <li className='tracking-wide'>
              <Link 
                to="home" 
                smooth={true} 
                spy={true} 
                activeClass="text-red-500 border-b-2 border-red-500"
                className="hover:text-sky-400"
                onClick={()=>{
                  setmenuOpened(false)
                }}
              >
                HOME
              </Link>
            </li>
            <li className='tracking-wide'>
              <Link 
                to='about' 
                smooth={true} 
                spy={true} 
                activeClass="text-red-500 border-b-2 border-red-500"
                className="hover:text-sky-300"
                onClick={()=>{
                  setmenuOpened(false)
                }}
              >
                ABOUT
              </Link>
            </li>
            <li className='tracking-wide'>
              <Link 
                to='skills' 
                smooth={true} 
                spy={true} 
                activeClass="text-red-500 border-b-2 border-red-500"
                className="hover:text-sky-300"
                onClick={()=>{
                  setmenuOpened(false)
                }}
              >
                SKILLS
              </Link>
            </li>
            <li className='tracking-wide'>
              <Link 
                to='project' 
                smooth={true} 
                spy={true} 
                activeClass="text-red-500 border-b-2 border-red-500"
                className="hover:text-sky-300"
                onClick={()=>{
                  setmenuOpened(false)
                }}
              >
                PROJECTS
              </Link>
            </li>
            <li className='tracking-wide '>
              <Link 
                to='contact' 
                smooth={true} 
                spy={true} 
                activeClass="text-red-500 border-b-2 border-red-500"
                className="hover:text-sky-300"
                onClick={()=>{
                  setmenuOpened(false)
                }}
              >
                CONTACT
              </Link>
            </li>
          </ul>
        </div>
      )
    }
        
    </div>
  );
};
